// api.js - UPDATED with common endpoint names
import axios from 'axios';

// Use environment variable or default to localhost for development
//We shlould also forward the backend server url from port forward and put that url here if we wish to share the frontend using port forwarding method.


const API_BASE_URL = process.env.REACT_APP_API_URL ;
console.log("API URL:", API_BASE_URL);

// const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://vxfs05b8-8000.inc1.devtunnels.ms/api/';

const api = axios.create({
  baseURL: API_BASE_URL,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      
      try {
        const refreshToken = localStorage.getItem('refreshToken');       
        const response = await axios.post(
          `${API_BASE_URL}token/refresh/`,
          { refresh: refreshToken }
        );
        
        const newToken = response.data.access;
        localStorage.setItem('token', newToken);
        
        originalRequest.headers.Authorization = `Bearer ${newToken}`;
        return axios(originalRequest);
      } catch (refreshError) {
        localStorage.clear();
        window.location.href = '/login';
        return Promise.reject(refreshError);
      }
    }
    
    return Promise.reject(error);
  }
);

// Blog API functions
export const blogApi = {
  // Categories
  getCategories: () => api.get('blog/categories/'),
  
  // Posts - Public
  getPosts: (params = {}) => api.get('blog/', { params }),
  getPost: (slug) => api.get(`blog/post/${slug}/`),
  
  // Posts - User actions
  createPost: (data) => api.post('blog/create/', data),
  updatePost: (postId, data) => api.put(`blog/post/${postId}/edit/`, data),
  deletePost: (postId) => api.delete(`blog/post/${postId}/edit/`),
  getMyPosts: () => api.get('blog/my-posts/'),
  
  // Engagement
  likePost: (postId) => api.post(`blog/post/${postId}/like/`),
  
  // Moderation (admin)
  getModerationQueue: (status = 'pending') => api.get('blog/moderation/', { params: { status } }),
  moderatePost: (postId, data) => api.post(`blog/moderation/${postId}/`, data),
};

// Admin API functions
export const adminApi = {
  // Dashboard stats
  getStats: () => api.get('admin/stats/'),
  
  // User management
  getUsers: (params = {}) => api.get('admin/users/', { params }),
  userAction: (userId, action) => api.post(`admin/users/${userId}/action/`, { action }),
};

export default api;